export default __webpack_public_path__ + "static/analiza-837f7a660c7a5f5b4d3983a3db46d528.jpeg";